import { render } from "./CutBox.vue?vue&type=template&id=1d2b6b68&scoped=true"
import script from "./CutBox.vue?vue&type=script&lang=js"
export * from "./CutBox.vue?vue&type=script&lang=js"

import "./CutBox.vue?vue&type=style&index=0&id=1d2b6b68&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d2b6b68"]])

export default __exports__